module.exports = __webpack_public_path__ + "img/34.7e3ba4d3.png";